import React, {Fragment, useEffect, useMemo, useState} from 'react'
import styles from './ThreeLevelDropdown.module.sass'
import DropdownElement from '../DropdownElement/DropdownElement'
import Popover from '../../../etc/Popover'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import Field from '../../../controls/Field/Field'
import {useObservableState} from 'observable-hooks'
import {fromQueryWithReset} from '../../../../utils/rx-operators'
//import InfiniteScroll from '../../../etc/scroll/InfiniteScroll'
import {Checkbox} from '../../../controls/Checkbox/Checkbox'
import clsx from 'clsx'
import {entityToggle, /*eqEntity,*/ getId, idToggle} from '../../../../utils/entity-utils'
import {Classes, Colors} from '../../../../styles'
//import {intersection} from 'fp-ts/Array'
import {Entity, ID} from '../../../../types/UtilityTypes'
import {ListResponse, Query} from '../../../../responses/response'
import {Observable} from 'rxjs'
import {TypedAjaxResponse} from '../../../../http/types'
import Button from '../../../controls/Button/Button'
import ChevronDownIcon from 'files/chevron/down.svg'
import Spacer from '../../../etc/Spacer'
import Ellipsis from '../../../etc/Ellipsis/Ellipsis'

interface Props<A, B, C> {
    className?: string,
    placeholder?: string,
    selection: A[],
    subselection: B[],
    subsubselection: C[],
    selector: (item: A) => B[],
    subselector: (item: B) => C[],
    render: (item: A) => string,
    subRender: (subItem: B) => string,
    subsubRender: (subItem: C) => string,
    request: (query: Query) => Observable<TypedAjaxResponse<ListResponse<A>>>
    onSelectionChange: (selection: A[]) => void,
    onSubselectionChange: (subselection: B[]) => void,
    onSubsubselectionChange: (subselection: C[]) => void,
}

const ThreeLevelDropdown = <A extends Entity, B extends Entity, C extends Entity>(props: Props<A, B, C>): JSX.Element => {
    const [opened, setOpened] = useState<ID[]>([])
    const [subOpened, setSubOpened] = useState<ID[]>([])
    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState('')
    const [data, getData] = useObservableState<A[], { search: string, reset: boolean }>(fromQueryWithReset(props.request), [])

    const count = props.selection.length + props.subselection.length + props.subsubselection.length
    const selectionIds = useMemo(() => props.selection.map(getId), [props.selection])
    const subselectionIds = useMemo(() => props.subselection.map(getId), [props.subselection])
    const subsubselectionIds = useMemo(() => props.subsubselection.map(getId), [props.subsubselection])

    useEffect(() => getData({search, reset: true}), [getData, search])

    return <Popover
        isOpen={open}
        onClickOutside={() => setOpen(false)}
        content={state => <ShadowContainer className={styles.dropdown} state={state}>
            <Field className={styles.field} value={search} onChange={setSearch}/>
            {/*<InfiniteScroll className={styles.list} onReach={() => getData({search, reset: false})}>*/}
            <div className={styles.list}>
                {data.map(item => {
                    const open = opened.includes(item.id)
                    return <Fragment key={item.id}>
                        <Checkbox
                            className={styles.line}
                            color={Colors.grey}
                            value={selectionIds.includes(item.id)}
                            onChange={() => props.onSelectionChange(entityToggle(item)(props.selection))}
                            //intermediate={intersection(eqEntity)(props.selector(item), props.subselection).length > 0}
                        >
                            <Ellipsis>{props.render(item)}</Ellipsis>
                            <Spacer/>
                            <Button onClick={event => {
                                event.stopPropagation()
                                setOpened(idToggle(item.id))
                            }}>
                                <ChevronDownIcon className={clsx({[Classes.flip]: open})}/>
                            </Button>
                        </Checkbox>
                        {
                            open && props.selector(item).map(subItem => {
                                const subOpen = subOpened.includes(`${item.id}_${subItem.id}`)

                                let subValueResult
                                if (subselectionIds.includes(subItem.id)) {
                                    if (selectionIds.includes(item.id)) {
                                        subValueResult = subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)
                                    } else {
                                        if (selectionIds.length === 0) {
                                            subValueResult = subselectionIds.includes(subItem.id)
                                        }
                                    }
                                }


                                return <Fragment key={`${item.id}_${subItem.id}`}>
                                    <Checkbox
                                        key={`${item.id}_${subItem.id}`}
                                        className={clsx(styles.line, styles.brand)}
                                        color={Colors.grey}
                                        value={subValueResult}
                                        onChange={() => {

                                            //Если пустой первый и второй уровень
                                            if (!subselectionIds.includes(subItem.id) && !selectionIds.includes(item.id)) {
                                                props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                                props.onSelectionChange(entityToggle(item)(props.selection))
                                            }
                                            //Если пустой первый уровень
                                            if (subselectionIds.includes(subItem.id) && !selectionIds.includes(item.id)) {
                                                props.onSelectionChange(entityToggle(item)(props.selection))
                                            }
                                            //Если пустой второй уровень
                                            if (!subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                            }
                                            //Если оба заполнены
                                            if (subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                            }

                                        }
                                        }
                                        //intermediate={intersection(eqEntity)(props.subselector(subItem), props.subsubselection).length > 0}
                                    >
                                        <Ellipsis>{props.subRender(subItem)}</Ellipsis>
                                        <Spacer/>
                                        <Button onClick={event => {
                                            event.stopPropagation()
                                            setSubOpened(idToggle(`${item.id}_${subItem.id}`))
                                        }}>
                                            <ChevronDownIcon className={clsx({[Classes.flip]: subOpen})}/>
                                        </Button>
                                    </Checkbox>
                                    {

                                        subOpen && props.subselector(subItem).map(subsubItem => {

                                                let subSubValueResult
                                                if (subsubselectionIds.includes(subsubItem.id)) {
                                                    if (subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                        // Третий уровень, второй уровень, первый уровень
                                                        subSubValueResult = subsubselectionIds.includes(subsubItem.id) && subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)
                                                    } else {
                                                        if (subselectionIds.includes(subItem.id)) {
                                                            subSubValueResult = subsubselectionIds.includes(subsubItem.id) && subselectionIds.includes(subItem.id)
                                                        } else {
                                                            if (subselectionIds.length === 0) {
                                                                if (selectionIds.includes(item.id)) {
                                                                    subSubValueResult = subsubselectionIds.includes(subsubItem.id) && selectionIds.includes(item.id)
                                                                } else {
                                                                    if(subsubselectionIds.includes(subsubItem.id)) {
                                                                        subSubValueResult = subsubselectionIds.includes(subsubItem.id)
                                                                    }
                                                                }
                                                            } else {
                                                                if(subsubselectionIds.includes(subsubItem.id)) {
                                                                    subSubValueResult = subsubselectionIds.includes(subsubItem.id)
                                                                }
                                                            }
                                                        }

                                                    }

                                                }


                                                return <Checkbox
                                                    key={`${item.id}_${subItem.id}_${subsubItem.id}`}
                                                    className={clsx(styles.line, styles.subitem)}
                                                    color={Colors.grey}
                                                    value={subSubValueResult}
                                                    onChange={() => {

                                                        // Если первый второй и третий уровни пустые
                                                        if (!subsubselectionIds.includes(subsubItem.id) && !subselectionIds.includes(subItem.id) && !selectionIds.includes(item.id)) {
                                                            props.onSubsubselectionChange(entityToggle(subsubItem)(props.subsubselection))
                                                            props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                                            props.onSelectionChange(entityToggle(item)(props.selection))
                                                        }

                                                        // Если пустой второй уровень
                                                        if (subsubselectionIds.includes(subsubItem.id) && !subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                            props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                                        }
                                                        //Если пустой первый уровень
                                                        if (subsubselectionIds.includes(subsubItem.id) && subselectionIds.includes(subItem.id) && !selectionIds.includes(item.id)) {
                                                            props.onSelectionChange(entityToggle(item)(props.selection))
                                                        }
                                                        if(!subsubselectionIds.includes(subsubItem.id) && subselectionIds.includes(subItem.id) && !selectionIds.includes(item.id)) {
                                                            props.onSubsubselectionChange(entityToggle(subsubItem)(props.subsubselection))
                                                            props.onSelectionChange(entityToggle(item)(props.selection))
                                                        }
                                                        //Если пустой третий уровень
                                                        if (!subsubselectionIds.includes(subsubItem.id) && subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                            props.onSubsubselectionChange(entityToggle(subsubItem)(props.subsubselection))
                                                        }

                                                        // Если пустые первый и второй уровень
                                                        if (subsubselectionIds.includes(subsubItem.id) && !subselectionIds.includes(subItem.id) && !selectionIds.includes(item.id)) {
                                                            props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                                            props.onSelectionChange(entityToggle(item)(props.selection))
                                                        }
                                                        //Если активен первый уровень, но не активны второй и третий
                                                        if(!subsubselectionIds.includes(subsubItem.id) && !subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                            props.onSubsubselectionChange(entityToggle(subsubItem)(props.subsubselection))
                                                            props.onSubselectionChange(entityToggle(subItem)(props.subselection))
                                                        }

                                                        // Если все активные
                                                        if (subsubselectionIds.includes(subsubItem.id) && subselectionIds.includes(subItem.id) && selectionIds.includes(item.id)) {
                                                            props.onSubsubselectionChange(entityToggle(subsubItem)(props.subsubselection))
                                                        }
                                                    }
                                                    }
                                                >
                                                    {props.subsubRender(subsubItem)}
                                                </Checkbox>
                                            }
                                        )
                                    }
                                </Fragment>
                            }
                            )
                            }
                            </Fragment>
                        })}
                    {/*</InfiniteScroll>*/}
                    </div>
                    </ShadowContainer>}
                    >
                    <DropdownElement
                    className={props.className}
                    active={open}
                    onToggle={setOpen}
                    placeholder={props.placeholder}
                    >
                {
                    count > 0 && <>
                    <div className={styles.count}>{count}</div>
                    <Ellipsis className={styles.content}>
                {[...props.selection.map(props.render), ...props.subselection.map(props.subRender), ...props.subsubselection.map(props.subsubRender)].join()}
                    </Ellipsis>
                    </>
                }
                    </DropdownElement>
                    </Popover>
                    }

                    export default ThreeLevelDropdown